module.exports = __webpack_public_path__ + "static/img/9.aa24eda.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/2/zh/9.png
// module id = HMd7
// module chunks = 0